<template>
  <li class="nav-item sep" :class="classArgs">
    <slot></slot>
  </li>
</template>

<script>
  import activeRoute from "../mixins/active-route";

  export default {
    name: "menu-list-item",
    props: {
      item: Object   
    },

    mixins: [activeRoute],

    computed: {

      
      classArgs() {
        return {
          active: this.activeRoute,
          "dropdown": this.item.children?.length > 0
        };
      },

    }
  };
</script>